export default __webpack_public_path__ + "static/media/right_widget_close_icon.bf07b3f9.svg";